import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M3 8h13v1H3V8zM3 12h13v1H3v-1z'],
  height: 20,
  width: 20,
});
